<!--<span [matTooltipClass]="'sweepstake-button-tooltip'" [matTooltip]="getSweepstakeTooltip() | translate">-->
<!--  <button class="puzzle-sweepstake-button"-->
<!--          (click)="sendSolutionWord()"-->
<!--          mat-icon-button-->
<!--          [disabled]="!getSweepstakeState()">-->
<!--    <mat-icon>send</mat-icon>-->
<!--  </button>-->
<span [tooltip]="getSweepstakeTooltip() | translate" placement="bottom">
  <ion-button class="puzzle-sweepstake-button"
              fill="solid"
              color="primary"
              (click)="sendSolutionWord()"
              [disabled]="!getSweepstakeState()">
    <ion-icon name="send-sharp" slot="icon-only"></ion-icon>
</ion-button>
</span>

<!--</span>-->
